var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "div",
        { staticClass: "subTitle" },
        [
          _c(
            "el-link",
            {
              attrs: {
                icon: "el-icon-arrow-left",
                underline: false,
                href: "#/campaignPopup"
              }
            },
            [_vm._v("Campaign Popup Management")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "h3",
        {
          staticClass: "title",
          attrs: { content: "edit", placement: "bottom" }
        },
        [_vm._v("Edit Campaign Popup")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "detailContent" },
        [
          _c("div", { staticClass: "requireRmarks" }, [
            _vm._v("*Required Fields")
          ]),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "formCampaign",
              staticClass: "formNotification",
              attrs: {
                "label-width": "50%",
                "label-position": "left",
                model: _vm.formCampaign,
                rules: _vm.formCampaignRules
              }
            },
            [
              _c("el-row", [_c("h4", [_vm._v("Title")])]),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 50 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "Sales Office", prop: "salesOffice" }
                        },
                        [
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.$commonjs.salesOfficeMap(
                                  _vm.formCampaign.salesOffice
                                )
                              )
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Title", prop: "title" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "Please enter",
                              maxlength: "50"
                            },
                            model: {
                              value: _vm.formCampaign.title,
                              callback: function($$v) {
                                _vm.$set(_vm.formCampaign, "title", $$v)
                              },
                              expression: "formCampaign.title"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-divider"),
              _vm._v(" "),
              _c("el-row", [
                _c("h4", { staticStyle: { "margin-bottom": "8px" } }, [
                  _vm._v("Images")
                ]),
                _vm._v(" "),
                _c(
                  "p",
                  { staticStyle: { "font-size": "14px", color: "#4f7a96" } },
                  [
                    _vm._v(
                      "\n          Suggeset size: 924(W) x 1386(H),Ratio 8:12\n        "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 50 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "1 image for all languages",
                            prop: "imageIsSame4All"
                          }
                        },
                        [
                          _c("el-switch", {
                            on: { change: _vm.handleSwitchChange },
                            model: {
                              value: _vm.formCampaign.imageIsSame4All,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.formCampaign,
                                  "imageIsSame4All",
                                  $$v
                                )
                              },
                              expression: "formCampaign.imageIsSame4All"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 50 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "- English", prop: "imageEn" } },
                        [
                          _c("upload-image", {
                            ref: "UploadImageEn",
                            attrs: {
                              fileParams: _vm.imageEnFileParams,
                              fileList: _vm.imageEnFileList,
                              limit: 1,
                              accept: "image"
                            },
                            on: { getSuccessRes: _vm.getImageEnRes }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "- Japanese",
                            prop: "imageJp",
                            rules: {
                              required: _vm.formCampaign.imageIsSame4All
                                ? false
                                : true,
                              message: "Image (JP) cannot be empty"
                            }
                          }
                        },
                        [
                          _c("upload-image", {
                            ref: "UploadImageJp",
                            attrs: {
                              fileParams: _vm.imageJpFileParams,
                              fileList: _vm.imageJpFileList,
                              limit: 1,
                              accept: "image",
                              disabled: _vm.formCampaign.imageIsSame4All
                            },
                            on: { getSuccessRes: _vm.getImageJpRes }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 50 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "- Traditional Chinese",
                            prop: "imageTc",
                            rules: {
                              required: _vm.formCampaign.imageIsSame4All
                                ? false
                                : true,
                              message: "Image (TC) cannot be empty"
                            }
                          }
                        },
                        [
                          _c("upload-image", {
                            ref: "UploadImageTc",
                            attrs: {
                              fileParams: _vm.imageTcFileParams,
                              fileList: _vm.imageTcFileList,
                              limit: 1,
                              accept: "image",
                              disabled: _vm.formCampaign.imageIsSame4All
                            },
                            on: { getSuccessRes: _vm.getImageTcRes }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "- Simplified Chinese",
                            prop: "imageSc",
                            rules: {
                              required: _vm.formCampaign.imageIsSame4All
                                ? false
                                : true,
                              message: "Image (SC) cannot be empty"
                            }
                          }
                        },
                        [
                          _c("upload-image", {
                            ref: "UploadImageSc",
                            attrs: {
                              fileParams: _vm.imageScFileParams,
                              fileList: _vm.imageScFileList,
                              limit: 1,
                              accept: "image",
                              disabled: _vm.formCampaign.imageIsSame4All
                            },
                            on: { getSuccessRes: _vm.getImageScRes }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-divider"),
              _vm._v(" "),
              _c("el-row", [_c("h4", [_vm._v("Button")])]),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 50 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "Button Type", prop: "button1Type" }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "Please select" },
                              on: {
                                change: function(v) {
                                  return _vm.handleButtonChecking(v, "1")
                                }
                              },
                              model: {
                                value: _vm.formCampaign.button1Type,
                                callback: function($$v) {
                                  _vm.$set(_vm.formCampaign, "button1Type", $$v)
                                },
                                expression: "formCampaign.button1Type"
                              }
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "None", value: "NONE" }
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "Go to URL", value: "URL" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.formCampaign.button1Type != "NONE"
                ? _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Button Name (EN)",
                                prop: "button1NameEn",
                                rules: {
                                  required:
                                    _vm.formCampaign.button1Type == "NONE"
                                      ? false
                                      : true,
                                  message: "Button Name (EN) cannot be empty"
                                }
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  maxlength: "15",
                                  placeholder: "Please enter",
                                  disabled:
                                    _vm.formCampaign.button1Type == "NONE"
                                },
                                model: {
                                  value: _vm.formCampaign.button1NameEn,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formCampaign,
                                      "button1NameEn",
                                      $$v
                                    )
                                  },
                                  expression: "formCampaign.button1NameEn"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Button Name (JP)",
                                prop: "button1NameJp",
                                rules: {
                                  required:
                                    _vm.formCampaign.button1Type == "NONE"
                                      ? false
                                      : true,
                                  message: "Button Name (JP) cannot be empty"
                                }
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  maxlength: "15",
                                  placeholder: "Please enter",
                                  disabled:
                                    _vm.formCampaign.button1Type == "NONE"
                                },
                                model: {
                                  value: _vm.formCampaign.button1NameJp,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formCampaign,
                                      "button1NameJp",
                                      $$v
                                    )
                                  },
                                  expression: "formCampaign.button1NameJp"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.formCampaign.button1Type != "NONE"
                ? _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Button Name (TC)",
                                prop: "button1NameTc",
                                rules: {
                                  required:
                                    _vm.formCampaign.button1Type == "NONE"
                                      ? false
                                      : true,
                                  message: "Button Name (TC) cannot be empty"
                                }
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  maxlength: "15",
                                  placeholder: "Please enter",
                                  disabled:
                                    _vm.formCampaign.button1Type == "NONE"
                                },
                                model: {
                                  value: _vm.formCampaign.button1NameTc,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formCampaign,
                                      "button1NameTc",
                                      $$v
                                    )
                                  },
                                  expression: "formCampaign.button1NameTc"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Button Name (SC)",
                                prop: "button1NameSc",
                                rules: {
                                  required:
                                    _vm.formCampaign.button1Type == "NONE"
                                      ? false
                                      : true,
                                  message: "Button Name (SC) cannot be empty"
                                }
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  maxlength: "15",
                                  placeholder: "Please enter",
                                  disabled:
                                    _vm.formCampaign.button1Type == "NONE"
                                },
                                model: {
                                  value: _vm.formCampaign.button1NameSc,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formCampaign,
                                      "button1NameSc",
                                      $$v
                                    )
                                  },
                                  expression: "formCampaign.button1NameSc"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.formCampaign.button1Type == "URL"
                ? _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "URL (EN)",
                                prop: "button1URLEn",
                                rules: {
                                  required:
                                    _vm.formCampaign.button1Type == "URL"
                                      ? true
                                      : false,
                                  message: "URL (EN) cannot be empty"
                                }
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "Please enter",
                                  disabled:
                                    _vm.formCampaign.button1Type !== "URL"
                                },
                                model: {
                                  value: _vm.formCampaign.button1URLEn,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formCampaign,
                                      "button1URLEn",
                                      $$v
                                    )
                                  },
                                  expression: "formCampaign.button1URLEn"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "URL (JP)",
                                prop: "button1URLJp",
                                rules: {
                                  required:
                                    _vm.formCampaign.button1Type == "URL"
                                      ? true
                                      : false,
                                  message: "URL (JP) cannot be empty"
                                }
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "Please enter",
                                  disabled:
                                    _vm.formCampaign.button1Type !== "URL"
                                },
                                model: {
                                  value: _vm.formCampaign.button1URLJp,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formCampaign,
                                      "button1URLJp",
                                      $$v
                                    )
                                  },
                                  expression: "formCampaign.button1URLJp"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.formCampaign.button1Type == "URL"
                ? _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "URL (TC)",
                                prop: "button1URLTc",
                                rules: {
                                  required:
                                    _vm.formCampaign.button1Type == "URL"
                                      ? true
                                      : false,
                                  message: "URL (TC) cannot be empty"
                                }
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "Please enter",
                                  disabled:
                                    _vm.formCampaign.button1Type !== "URL"
                                },
                                model: {
                                  value: _vm.formCampaign.button1URLTc,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formCampaign,
                                      "button1URLTc",
                                      $$v
                                    )
                                  },
                                  expression: "formCampaign.button1URLTc"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "URL (SC)",
                                prop: "button1URLSc",
                                rules: {
                                  required:
                                    _vm.formCampaign.button1Type == "URL"
                                      ? true
                                      : false,
                                  message: "URL (SC) cannot be empty"
                                }
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "Please enter",
                                  disabled:
                                    _vm.formCampaign.button1Type !== "URL"
                                },
                                model: {
                                  value: _vm.formCampaign.button1URLSc,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formCampaign,
                                      "button1URLSc",
                                      $$v
                                    )
                                  },
                                  expression: "formCampaign.button1URLSc"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("el-divider"),
              _vm._v(" "),
              _c("el-row", [_c("h4", [_vm._v("Status")])]),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 50 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Post Online", prop: "postOnline" } },
                        [
                          _c("el-switch", {
                            model: {
                              value: _vm.formCampaign.postOnline,
                              callback: function($$v) {
                                _vm.$set(_vm.formCampaign, "postOnline", $$v)
                              },
                              expression: "formCampaign.postOnline"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "Last update by", prop: "updateBy" }
                        },
                        [_c("p", [_vm._v(_vm._s(_vm.formCampaign.updateBy))])]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        {
          staticStyle: { padding: "25px 0" },
          attrs: { type: "flex", justify: "end", gutter: 20 }
        },
        [
          _vm.formCampaign.status != "REVOKED_PENDING" &&
          _vm.formCampaign.status != "REVOKED_DELIVERED"
            ? _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _vm.showSave
                    ? _c(
                        "el-button",
                        {
                          staticClass: "reset",
                          staticStyle: { width: "100%" },
                          on: { click: _vm.handleCancel }
                        },
                        [_vm._v("Cancel")]
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.formCampaign.status != "REVOKED_PENDING" &&
          _vm.formCampaign.status != "REVOKED_DELIVERED"
            ? _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _vm.showSave
                    ? _c(
                        "el-button",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { type: "primary" },
                          on: { click: _vm.handleSave }
                        },
                        [_vm._v("Save")]
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-18be80fe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18be80fe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/notification/editCampaign.vue
// module id = null
// module chunks = 